import {SPEED} from "./cooks";

export type MoveCommand = {
    left: boolean
    right: boolean
    up: boolean
    down: boolean
}

export type DropOrPickCommand = {
}

export const prettyMoveCommand = ({left, right, up, down}: MoveCommand): string =>
    [left ? "left" : '-', right ? "right" : '-', up ? "up" : '-', down ? "down" : '-'].toString();

export function velocityFromCommand(cmd: MoveCommand): {vx: number, vy: number} {
    let vx = 0;
    let vy = 0;
    if (cmd.left) vx -= SPEED;
    if (cmd.right) vx += SPEED;
    if (cmd.up) vy -= SPEED;
    if (cmd.down) vy += SPEED;
    return {vx, vy};
}

export function computeFacingCommand(cookX: number, cookY: number, targetX: number, targetY: number): MoveCommand {
    const dx = targetX - cookX;
    const dy = targetY - cookY;
    // Use the dominant axis to decide direction
    if (Math.abs(dx) >= Math.abs(dy)) {
        return { left: dx < 0, right: dx > 0, up: false, down: false };
    }
    return { left: false, right: false, up: dy < 0, down: dy > 0 };
}
